import React from "react";
import styled from "styled-components";
//
export default ({ address_1, address_2, city, email, postcode, telephone }) => (
  <Address>
    {address_1 && <Span>{address_1},</Span>}
    {address_2 && <Span>{address_2},</Span>}
    {city && <Span>{city}</Span>}
    {postcode && <Span>{postcode}</Span>}
    {telephone && <Span>{telephone}</Span>}
    {email && (
      <Email href={`mailto:${email}`} title={email}>
        {email}
      </Email>
    )}
  </Address>
);
//
const Address = styled.address`
  align-self: end;
  font-style: normal;
  grid-area: address;
  justify-self: end;
  max-width: 200px;
  opacity: 0.3;
  padding: 1rem 0.5rem;
`;

const Span = styled.span`
  display: block;
`;

const Email = styled.a`
  display: block;
`;
